import { Link } from "react-router-dom";
import type { Work } from "@/mocks/works";

export function formatCount(n: number): string {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return `${n}`;
}

export default function WorkCard({ work }: { work: Work }) {
  return (
    <Link
      to={`/works/${work.id}`}
      className="group flex flex-col overflow-hidden rounded-lg bg-background-100 transition-all hover:-translate-y-0.5 hover:bg-background-50"
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
        <img
          src={work.cover}
          alt={`${work.title} - ${work.characterName}同人作品封面`}
          title={`${work.title} · ${work.characterName}同人`}
          loading="lazy"
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-medium text-background-50 ${
            work.status === "连载中" ? "bg-accent-500" : "bg-secondary-500"
          }`}
        >
          {work.status}
        </span>
        <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-foreground-950/60 px-2 py-0.5 text-xs text-background-50">
          <i className="ri-heart-3-fill text-accent-300" aria-hidden="true"></i>
          {formatCount(work.likes)}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex items-center gap-2">
          <span className="rounded-md bg-primary-500/10 px-2 py-0.5 text-xs font-medium text-primary-700">
            {work.characterName}
          </span>
        </div>
        <h3 className="mt-2 line-clamp-1 font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
          {work.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-xs leading-relaxed text-foreground-600 md:text-sm">
          {work.summary}
        </p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {work.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="rounded bg-background-200 px-2 py-0.5 text-xs text-foreground-700">
              #{tag}
            </span>
          ))}
        </div>

        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-600">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" aria-hidden="true"></i>
            {formatCount(work.views)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-file-list-3-line" aria-hidden="true"></i>
            {work.chapters}话
          </span>
          <span>{work.updatedAt}</span>
        </div>
      </div>
    </Link>
  );
}